function getNewXIndex(xIndex:number, value:number, max:number, allowWrapping:boolean) {
	let newIndex = xIndex + value;
	if(newIndex > max-1) {
		return allowWrapping ? 0 : max-1;
	} else if (newIndex < 0) {
		return allowWrapping ? max-1 : 0;
	}
	return newIndex;
}

export { getNewXIndex };
